import React, { useContext, useState, useRef, useEffect } from "react";
import styled, { css } from "styled-components";
import ReactHtmlParser from "react-html-parser";
import { EventContext, AnalyticsContext, TempContext } from "context";
import { PrimaryTemplate as Layout } from "Layout/Templates";
import { MaxWidthContainer } from "Layout/MaxWidthContainer";
import { ButtonPrimary } from "Components";
import { RegistrationForm } from "Components/Form";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMediaQuery } from "hooks/useMediaQuery";
import newFlavor from "Components/Assets/NEW-FLAVOR.png";
import updownWave from "Components/Assets/Wave2-2.png";
import { Parallax } from "react-scroll-parallax";
import drPcans from "../../../img/DrPepperCans1.png";
import artist from "../../../img/artist12.png";
import berry from "../../../img/Strawberry1.png";
import Vector from "../../../img/topwave-21.png";
import Aos from "aos";
import "aos/dist/aos.css";

export const RegistrationLayout = React.memo(
  ({
    sweeps,
    ineligible,
    formStep = 0,
    registered,
    postCampaign,
    setIneligible,
  }) => {
    const { event } = useContext(EventContext);
    const { logVideoAction, logClick } = useContext(AnalyticsContext);

    const [open, setOpen] = useState(false);
    const [video, setVideo] = useState(null);

    const isDesktop = useMediaQuery("(min-width: 950px)");
    const isSmallScreen = useMediaQuery("(max-width: 550px)");

    const api = process.env.REACT_APP_FIRE_BASE_STORAGE_API;
    const storageDirectory = event?.meta?.storageDirectory;

    // logo
    const { brand: brandLogo, hero, link, brand } = event?.logos;
    let brandLogoImg = `${api}/o/${storageDirectory}%2F${brandLogo?.image}?alt=media`;

    let headlineImgReg = `${api}/o/${storageDirectory}%2F${hero?.imageReg}?alt=media`;
    let headlineImgPostReg = `${api}/o/${storageDirectory}%2F${hero?.imagePostReg}?alt=media`;
    let headlineMobImgReg = `${api}/o/${storageDirectory}%2F${hero?.imageMobReg}?alt=media`;
    let headlineImgMobPostReg = `${api}/o/${storageDirectory}%2F${hero?.imageMobPostReg}?alt=media`;
    let headlineImgPostCamp = `${api}/o/${storageDirectory}%2F${hero?.imagePostCamp}?alt=media`;
    let headlineImgMobPostCamp = `${api}/o/${storageDirectory}%2F${hero?.imageMobPostCamp}?alt=media`;

    if (registered) formStep = event?.register.sweeps.length - 1;

    // registration content
    const {
      heading,
      subHeading,
      subHeadingPostReg,
      subBodyPostSweep,
      body,
      bodyPostSweep,
      bodyPostReg,
      formHeading,
      formLegal,
      formPolicy,
      submit,
      pageCheck,
    } = sweeps
      ? event?.register.sweeps[formStep]
      : event?.register.postSweeps[formStep];

    // ineligible content
    const {
      heading: ineligibleHeading,
      body: ineligibleBody,
      postRegBody,
    } = event?.register;

    // music video background
    const {
      background: musicVideoBg,
      label: musicVideoLabel,
      video: musicVideoLink,
    } = event?.callToActions.musicVideo;
    // let videoBgDesktop = `${api}/o/${storageDirectory}%2F${musicVideoBg.desktop}?alt=media`;
    let videoBgMobile = `${api}/o/${storageDirectory}%2F${musicVideoBg.mobile}?alt=media`;

    // brand cta
    const {
      btnLink: brandCTALink,
      btnText: brandCTAText,
      heading: brandCTAHeading,
    } = event?.callToActions.brand;

    // brand cta background
    const {
      desktop: brandBgD,
      mobile: brandBgM,
    } = event?.callToActions.brand.background;
    let brandBgDesktop = `${api}/o/${storageDirectory}%2F${brandBgD}?alt=media`;
    let brandBgMobile = `${api}/o/${storageDirectory}%2F${brandBgM}?alt=media`;

    // brand product background
    const {
      desktop: brandProductDesktop,
      mobile: brandProductMobile,
    } = event?.callToActions.brand.product;
    let productDesktop = `${api}/o/${storageDirectory}%2F${brandProductDesktop}?alt=media`;
    let productMobile = `${api}/o/${storageDirectory}%2F${brandProductMobile}?alt=media`;

    // post-campaign content
    const {
      heading: postCampaignHeading,
      subHeading: postCampaignSubHeading,
      body: postCampaignBody,
      subBody,
      imagePostCamp,
    } = event?.postCampaign;
    let imgPostCamp = `${api}/o/${storageDirectory}%2F${imagePostCamp}?alt=media`;
    // brand cta (post-campaign)
    const {
      btnLink: brandSecondaryCTALink,
      btnText: brandSecondaryCTAText,
      heading: brandSecondaryCTAHeading,
    } = event?.callToActions.brandSecondary;

    const {
      song,
      videoHero: { desktop, mobile },
    } = event?.callToActions?.artists;

    const logoClickHandler = (link) => {
      logClick({ label: "Header Logo", url: link });
    };

    const linkClickHandler = (url, label, category) => {
      logClick({ label, url }, category);
    };

    const setModalVisible = (bool, link) => {
      setVideo(link);
      setOpen(bool);
      logVideoAction({ bool, videoLink: link, videoTitle: "Hero Video" });
    };

    const formScreen = useRef(null);

    useEffect(() => {
      Aos.init({ duration: 1200, once: true });
    }, []);

    return (
      <Layout
        registration={postCampaign ? false : true}
        flexGrow
        showFooter
        registered={registered}
        postCampaign={postCampaign}
      >
        <Container postCampaign={postCampaign}>
          <Content>
            <LogoBox>
              <StyledLink
                href={brandLogo.link}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => logoClickHandler(brandLogo.link)}
              >
                {brandLogoImg && <Logo id="brand" src={brandLogoImg} />}
              </StyledLink>
            </LogoBox>
            {postCampaign && postCampaignBody ? (
              <>
                <ImageReg
                  src={isDesktop ? headlineImgPostCamp : headlineImgMobPostCamp}
                  alt="the futuristic vip fan experience with dr pepper"
                />
                <BodyPostCampaign>
                  {ReactHtmlParser(postCampaignBody)}
                </BodyPostCampaign>
              </>
            ) : (
              <>
                {isDesktop ? (
                  <ImageReg
                    src={registered ? headlineImgPostReg : headlineImgReg}
                    alt="the futuristic vip fan experience with dr pepper"
                  />
                ) : (
                  <ImageReg
                    src={registered ? headlineImgMobPostReg : headlineMobImgReg}
                    alt="the futuristic vip fan experience with dr pepper"
                  />
                )}
                {registered && bodyPostReg && (
                  <BodyPostCampaign>
                    {ReactHtmlParser(bodyPostReg)}
                  </BodyPostCampaign>
                )}
              </>
            )}
            <ContainerPadding ref={formScreen}>
              {isDesktop ? (
                <Parallax
                  translateX={["100px", "-1000px"]}
                  // scale={[2, 3]}
                  easing="easeInQuad"
                >
                  <img
                    src={Vector}
                    style={{
                      width: "400%",
                      position: "absolute",
                      top: "20%",
                      left: "-5%",
                      zIndex: "0",
                      transform: "translate(-300px,150px)",
                    }}
                    alt=""
                  />
                </Parallax>
              ) : (
                <Parallax translateX={["100px", "-500px"]} easing="easeInQuad">
                  <img
                    src={Vector}
                    style={{
                      width: "400%",
                      position: "absolute",
                      top: "45%",
                      zIndex: "0",
                      left: "-20%",
                      transform: "translate(-100px,100px)",
                    }}
                    alt=""
                  />
                </Parallax>
              )}
              {isDesktop ? (
                <>
                  <Parallax
                    rotate={["-2", "5"]}
                    translateY={["-50px", "200px"]}
                  >
                    <img
                      src={berry}
                      style={{
                        transform: "scale(0.7)",
                        position: "absolute",
                        zIndex: "10",
                        left: "-27%",
                      }}
                      alt=""
                    />{" "}
                  </Parallax>
                  <Parallax
                    rotate={["-30", "10"]}
                    translateY={["-220px", "60px"]}
                  >
                    <img
                      src={berry}
                      style={{
                        transform: "scale(0.8) rotate(70deg)",
                        position: "absolute",
                        zIndex: "10",
                        right: "-23%",
                        top: 0,
                      }}
                      alt=""
                    />
                  </Parallax>
                </>
              ) : (
                <>
                  {(registered || postCampaign) && (
                    <Parallax
                      rotate={["-15", "5"]}
                      translateY={["-50px", "70px"]}
                    >
                      <img
                        src={berry}
                        style={{
                          transform: "scale(0.5)",
                          position: "absolute",
                          zIndex: "10",
                          left: "-24%",
                        }}
                        alt=""
                      />{" "}
                    </Parallax>
                  )}
                  <Parallax
                    translateY={["-250px", "15px"]}
                    rotate={["-15", "5"]}
                  >
                    <img
                      src={berry}
                      style={{
                        transform: "scale(0.6) rotate(70deg)",
                        position: "absolute",
                        zIndex: "10",
                        right: "-22%",
                        top: 0,
                      }}
                      alt=""
                    />
                  </Parallax>
                </>
              )}

              <Parallax easing="easeInQuad">
                <img
                  src={artist}
                  style={{
                    width: "100%",
                    zIndex: "10",
                  }}
                  alt=""
                />
              </Parallax>
            </ContainerPadding>
          </Content>
        </Container>
        <Container form={true}>
          <Content>
            <ContainerPadding>
              {!registered &&
                !postCampaign &&
                (isDesktop ? (
                  <>
                    <Parallax
                      rotate={["-3", "10"]}
                      translateY={["70px", "240px"]}
                    >
                      <img
                        src={berry}
                        style={{
                          transform: "scale(0.6) rotate(70deg)",
                          position: "absolute",
                          zIndex: "10",
                          left: "-27%",
                        }}
                        alt=""
                      />
                    </Parallax>
                    <Parallax
                      rotate={["1", "-6"]}
                      translateY={["-20px", "150px"]}
                    >
                      <img
                        src={berry}
                        style={{
                          transform: "scale(0.5)",
                          position: "absolute",
                          zIndex: "10",
                          right: "-23%",
                        }}
                        alt=""
                      />
                    </Parallax>
                  </>
                ) : (
                  <>
                    <Parallax translateY={["-50px", "120px"]}>
                      <img
                        src={berry}
                        style={{
                          transform: "scale(0.4) rotate(70deg)",
                          position: "absolute",
                          zIndex: "10",
                          left: "-27%",
                        }}
                        alt=""
                      />
                    </Parallax>
                    <Parallax
                      rotate={["25", "-5"]}
                      translateY={["30px", "230px"]}
                    >
                      <img
                        src={berry}
                        style={{
                          transform: "scale(0.5)",
                          position: "absolute",
                          zIndex: "10",
                          right: "-23%",
                        }}
                        alt=""
                      />
                    </Parallax>
                  </>
                ))}
              {!postCampaign ? (
                <>
                  {!registered ? (
                    <>
                      {pageCheck && (
                        <>
                          <BodyPostSweep>
                            {ReactHtmlParser(bodyPostSweep)}
                          </BodyPostSweep>
                          <SubBodyPostSweep>
                            {ReactHtmlParser(subBodyPostSweep)}
                          </SubBodyPostSweep>
                        </>
                      )}

                      {/* ===== REGISTRATION FORM ===== */}
                      {!registered && (
                        <RegistrationForm
                          formPart={formStep}
                          formHeading={formHeading}
                          formLegal={formLegal}
                          formPolicy={formPolicy}
                          submitButton={submit}
                          setIneligible={setIneligible}
                        />
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <></>
              )}
            </ContainerPadding>

            <ArtistSection>
              {isDesktop ? (
                <Parallax
                  translateX={["0px", "-1000px"]}
                  easing="easeInQuad"
                  style={{ position: "absolute", zIndex: "50" }}
                >
                  <img
                    src={updownWave}
                    style={{
                      width: "3000px",
                      position: "absolute",
                      top: "0%",
                      left: "-20%",
                      zIndex: "10",
                    }}
                    alt=""
                  />
                </Parallax>
              ) : (
                <Parallax translateX={["100px", "-400px"]} easing="easeInQuad">
                  <img
                    src={updownWave}
                    style={{
                      width: "1600px",
                      position: "absolute",
                      top: "0%",
                      zIndex: "10",
                      left: "-20%",
                      transform: "translate(-30px,-30px)",
                    }}
                    alt=""
                  />
                </Parallax>
              )}
              <ArtistImageBox>
                <SongWrapper>
                  <SpotifyPlayer
                    src={song.spotify}
                    allowfullscreen=""
                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                  />
                </SongWrapper>
              </ArtistImageBox>
              <BrandBox>
                <img
                  src={postCampaign ? imgPostCamp : newFlavor}
                  alt="new flavor you deserve"
                />
                {postCampaign
                  ? subBody && <Body>{subBody}</Body>
                  : body && <Body>{body}</Body>}

                <img src={drPcans} id="product" alt="new flavor you deserve" />

                {isDesktop ? (
                  <Parallax
                    style={{ width: "100%" }}
                    rotate={["-2", "20"]}
                    translateY={["-20px", "120px"]}
                  >
                    <img
                      src={berry}
                      id="berry"
                      style={{
                        transform: "scale(0.8) rotate(70deg)",
                        position: "absolute",
                        zIndex: 70,
                        right: 0,
                        bottom: 0,
                      }}
                      alt=""
                    />
                  </Parallax>
                ) : (
                  <Parallax
                    style={{ width: "100%" }}
                    rotate={["-15", "15"]}
                    translateY={["-320px", "10px"]}
                  >
                    <img
                      src={berry}
                      id="berry"
                      style={{
                        transform: "scale(0.6) rotate(70deg)",
                        position: "absolute",
                        zIndex: 70,
                        right: 30,
                        bottom: 0,
                      }}
                      alt=""
                    />
                  </Parallax>
                )}

                {!isDesktop && (
                  <Parallax
                    translateX={["-400px", "-1000px"]}
                    easing="easeInQuad"
                  >
                    <img
                      src={Vector}
                      style={{
                        height: "400px",
                        width: "1500px",
                        position: "absolute",
                        top: "100%",
                        bottom: "-10%",
                        zIndex: "10",
                        left: "-20%",
                        transform: "translate(-70px, 20px)",
                      }}
                      alt=""
                    />
                  </Parallax>
                )}
              </BrandBox>
            </ArtistSection>
          </Content>
        </Container>
      </Layout>
    );
  }
);

const Container = styled(MaxWidthContainer)`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0 0 0 0;
  margin-bottom: -7px;
  background-color: #951c2f;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    flex-direction: row;
    padding: 0;
  }
  ${({ form }) =>
    form &&
    css`
      background-color: #e88597;
      margin-top: -50px;
      padding-top: 20px;
    `}
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-shrink: 0;
  flex: 1;
  align-items: center;
  order: 0;
  position: relative;
  overflow: hidden;

  @media (max-width: 950px) {
    padding: 0 0px;
    order: 1;
    /* position: relative; */
  }
`;

const ContainerPadding = styled.div`
  position: relative;
  padding: 0px 60px 0 60px;
  width: 100%;
  max-width: 750px;
  h1 {
    font-size: 40px;
    margin: -20px 0 20px;
  }

  @media (max-width: 950px) {
    padding: 0px 30px 0 30px;

    h1 {
      font-size: 26px;
      margin: -20px 0 20px;
    }

    div#bodyMobile {
      position: absolute;
      top: 35%;
      z-index: 30;
      padding: 10% 0 0 5px;
      left: 10%;
      margin-top: -20%;
    }

    /* & > img {
      position: absolute;
      width: 80%;
      top: 23%;
      z-index: 30;
      padding: 0;
      left: 10%;
    } */
  }
`;
const ArtistSection = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 20px 0 25px;
  padding-top: 100px;
  position: relative;
  @media (max-width: 950px) {
    grid-template-columns: 1fr;
    padding-top: 10px;
    padding-bottom: 25px;
    background-color: #951c2f;
  }
`;
const ArtistImageBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 95%;
  background-image: url("https://storage.googleapis.com/whitelabel-set-live.appspot.com/663-dr-pepper-futuristic/artistDrPepper.png");
  background-position: bottom center;
  background-size: cover;
  background-repeat: no-repeat;
`;
const Body = styled.p`
  color: #fff;
  font-size: min(1vw, 16px);
  line-height: 22px;
  /* margin: 40px 0 20px; */
  z-index: 40;

  & > span {
    display: block;
    margin-top: 20px;
    font-size: 1.5rem;
    font-weight: 900;
  }

  @media (max-width: 950px) {
    font-size: max(1vw, 16px);
  }
`;
const BrandBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  position: relative;
  height: 100%;
  background-color: #951c2f;
  background-image: url("https://storage.googleapis.com/whitelabel-set-live.appspot.com/663-dr-pepper-futuristic/RedPinkBg.png");
  background-position: bottom center;
  background-size: cover;
  background-repeat: no-repeat;
  padding-top: 20%;
  ${Body} {
    text-align: center;
    width: 80%;
    margin-top: 30px;
    z-index: 30;
  }
  img {
    margin: 0 auto;
    width: 40%;
    z-index: 30;
    @media (max-width: 950px) {
      width: 60%;
    }
  }
  img#product {
    position: absolute;
    bottom: 10%;
    top: 50%;
    @media (max-width: 950px) {
      position: relative;
      top: 0%;
    }
  }
  img#berry {
    position: absolute;
    bottom: 0;
    top: 100%;
    width: 150px;
    right: -10%;
    left: 70%;
    z-index: 70;
    @media (max-width: 950px) {
      position: absolute;
      top: 0%;
    }
  }
  @media (max-width: 950px) {
    background-image: none;
    padding-top: 45px;
    height: 170vw;
    max-height: 770px;
    max-width: 500px;
    margin: 0 auto;
  }
`;
const ImageReg = styled.img`
  width: 60%;
  margin: 0 auto;
  max-width: 700px;
  @media (max-width: 950px) {
    width: 80%;
    max-width: 400px;
  }
`;
const Berry1 = styled.img`
  width: 70px;
  position: absolute;
  top: 20%;
  left: 0;
  z-index: 10;
  ${({ isSmallScreen }) =>
    isSmallScreen &&
    css`
      top: -5%;
      width: 60px;
      left: 3%;
      z-index: 0;
    `}
  ${({ isSmallScreen, top }) =>
    !isSmallScreen &&
    top &&
    css`
      width: 100px;
    `}
`;

const Berry2 = styled.img`
  width: 70px;
  position: absolute;
  top: 10%;
  right: 0;
  z-index: 10;
  ${({ isSmallScreen }) =>
    isSmallScreen &&
    css`
      right: 1%;
      width: 40px;
    `}
  ${({ isSmallScreen, top }) =>
    !isSmallScreen &&
    top &&
    css`
      width: 110px;
    `}
`;

const ScrollContainer = styled.div`
  @media (min-width: 950px) {
    display: none;
  }

  position: absolute;
  bottom: 10%;
  left: 45%;
  color: white;
  text-align: center;
  z-index: 50;
  font-size: 2rem;
  width: 50px;
  height: 50px;
  border: 3px solid white;
  border-radius: 50px;
  background: transparent;
`;

const ArtistContent = styled.div`
  display: flex;
  flex: 1;
  order: 1;

  @media (max-width: 950px) {
    order: 0;
    flex-direction: column;
    position: relative;
  }
`;

const VideoContainer = styled.div`
  position: relative;
  z-index: 1;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  overflow: hidden;

  @media (max-width: 950px) {
    margin-bottom: 7px;
  }
`;
const TextContainer = styled.div`
  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    width: 25%;
    position: absolute;
    top: 45%;
    left: 60%;
  }
  z-index: 10;

  @media (max-width: 950px) {
    display: flex;
    flex-direction: row-reverse;
    margin-top: 20px;
    width: 100%;
    position: absolute;
    top: 0;
    left: -40%;
    z-index: 10;

    & > img#text {
      display: none;
    }

    & > a {
      display: none;
    }
  }
`;

const TextLogoBox = styled.div`
  padding-bottom: 30px;
  display: flex;
  justify-content: flex-start;
  align-self: flex-start;
  z-index: 40;
  position: relative;

  & > img#register {
    @media (max-width: 950px) {
      width: 100%;
      padding: 0;
    }
  }
`;

const LogoBox = styled.div`
  padding: 20px;
  display: flex;
  justify-content: center;
  align-self: center;
  width: 100%;
`;

const RegLogoContainer = styled.div`
  padding: 0 20px;
`;

const AdContainer = styled.div`
  padding: 30px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-self: flex-start;
  background-color: black;
  margin-bottom: -20px;

  & > img#postReg {
    /* --> desktop */
    @media (min-width: 950px) {
      width: 45%;
      margin: 0;
    }
  }

  @media (max-width: 950px) {
    padding-top: 80px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: -20%;
  }

  @media (max-width: 580px) {
    padding-top: 120px;
    margin-top: -40%;
    z-index: 1;
  }
`;

const AdWrapper = styled.div`
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  background-color: black;

  @media (max-width: 950px) {
    padding: 20px 45px;
  }
`;

const StyledLink = styled.a`
  width: 100%;
  max-width: 100px;
  color: #951c2b;
  text-decoration: none;
  font-family: aktiv-grotesk-extended, sans-serif;
  font-size: 1rem;
  font-weight: 700;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    max-width: 92px;
  }
`;

const StyledIcon = styled(FontAwesomeIcon)`
  margin-right: 5px;
`;

const StyledLinkForward = styled(Link)`
  color: #000;
  width: 70%;
  background: #ffbc0d;
  padding: 10px 10px 8px 10px;
  text-decoration: none;
  border-radius: 5px;
  margin-bottom: 10px;
  font-size: 0.9rem;
  font-weight: 500;

  @media (min-width: 950px) {
    min-width: 250px;
  }

  @media (max-width: 950px) {
    font-size: 0.6em;
    margin-right: 7px;
    padding: 10px 0px 8px 8px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  @media (max-width: 550px) {
    flex-direction: row;
    margin-bottom: -50px;
  }

  @media (min-width: 551px) and (max-width: 950px) {
    flex-direction: column;
    margin-bottom: -50px;
    width: 60%;
  }
`;

const Logo = styled.img`
  width: 100%;
  z-index: 40;
  margin: 0 auto;
`;

const AdImageBox = styled.img`
  width: 55%;
  margin-bottom: -10px;
  margin-left: 15%;

  @media (max-width: 950px) {
    width: 70%;
    margin: 0 auto -10px auto;
    align-self: center;
  }
`;

const SpotifyPlayer = styled.iframe`
  height: 80px;
  width: 100%;
  border: 0;
  border-radius: 0;
  margin-top: auto;
  z-index: 100;
`;

const SongWrapper = styled.div`
  width: 100%;
  background-color: #242424;
`;

const WatchButton = styled(ButtonPrimary)`
  font-family: aktiv-grotesk-extended, sans-serif;
  font-size: 1rem;
  font-weight: 700;
  z-index: 50;
  width: 60%;
  min-width: 210px;

  @media (max-width: 950px) {
    width: 45vw;
    display: none;
  }
`;

const MainHeading = styled.h1`
  border-bottom: 2px solid #fff;
  padding-bottom: 10px;
  color: #fff;
  margin-bottom: 10px;
  font-size: 2.2rem;
  text-align: center;
`;

const Heading = styled.h2``;

const SubHeading = styled.h3`
  color: #fff;
  font-size: 1.5rem;
  margin-top: 15px;
  margin-bottom: 0px;
  text-align: center;

  & > span {
    margin-top: -8px;
    display: block;
    font-size: 3rem;
    text-align: center;
  }
`;

const BodyPostSweep = styled.p`
  color: #292929;
  font-size: 1rem;
  line-height: 140%;
  font-weight: 500;
  z-index: 40;
`;

const SubBodyPostSweep = styled.p`
  color: #ffbc0d;
  font-size: 1rem;
  font-weight: 500;
  padding-right: 40px;
  line-height: 140%;
  z-index: 40;
`;
const HeadingPostCampaign = styled(Heading)`
  color: #fff;
  font-size: 3rem;
`;

const SubHeadingPostCampaign = styled.h3`
  color: #2d2d2d;
  font-weight: 500;
  font-size: 1.05rem;
  padding-right: 30px;

  @media (max-width: 950px) {
    line-height: 100%;
  }
`;

const BodyPostCampaign = styled.div`
  font-size: 1rem;
  color: white;
  text-align: center;
  margin: 20px;
  @media (max-width: 950px) {
    font-size: 0.85rem;
  }
`;

const topBorder = `
  border-top: 0px solid #707070;
  padding-top: 24px;
  margin-top: 24px;
`;

const PoweredBy = styled.div`
  ${topBorder}
`;

const BrandSecondaryCTA = styled.div`
  ${topBorder}
`;

const ArtistContentTop = styled.div`
  display: flex;
`;

const BrandImage = styled.div`
  flex: 1;
  background-image: url(${(props) => props.mobile});
  background-position: bottom;
  background-size: cover;
  padding-top: 56.25%;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    background-image: url(${(props) => props.desktop});
    background-position: center;
  }

  @media (max-width: 950px) {
    padding-top: 80%;
    margin-bottom: -30px;
    margin-top: -30px;
  }
`;

const HeroVideoMobile = styled.div`
  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    display: none;
  }
`;

const HeroVideoDesktop = styled.div`
  display: none;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    display: flex;
    width: 66%;
  }
`;

const MusicVideo = styled.div`
  position: relative;
  overflow: hidden;
  cursor: pointer;

  & > img {
    transition: all 0.3s;
    -webkit-transition: all 0.3s;
    aspect-ratio: 16/9;
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  &:hover > img {
    transform: scale(1.1);
    -webkit-transform: scale(1.1);
  }

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    flex: 1 1 0%;
    padding: 0;
  }
`;

const MobileImage = styled.img`
  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    display: none;
  }
`;

const DesktopImage = styled.img`
  display: none;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    display: block;
  }
`;

const BrandCTA = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: center;
  aspect-ratio: 16/9;
  position: relative;
  overflow: hidden;
  cursor: pointer;

  & > img {
    position: absolute;
    transition: all 0.3s;
    -webkit-transition: all 0.3s;
    aspect-ratio: 16/9;
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  &:hover > img {
    transform: scale(1.1);
    -webkit-transform: scale(1.1);
  }

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    & > img {
      width: 150%;
    }
  }
`;

const BrandCTAHeading = styled.h3`
  color: #ffffff;
  padding: 0 20px;
  margin: 0 0 40px;
  z-index: 1;
`;
const Label = styled.div`
  background-color: rgba(0, 9, 91, 0.9);
  color: #ffffff;
  padding: 10px 20px;
  width: 100%;
  cursor: pointer;
  position: absolute;
  bottom: 0;
  text-decoration: none;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    font-size: 12px;
  }
`;
